(() => {
  const selector = '.product-card__media img.secondary-image';
  const update = image => {
    if (!image.matches?.(selector)) return;
    image.classList.toggle('is-loaded', image.complete && image.naturalWidth > 0);
  };
  // Capture also covers cards inserted later by recommendations or the theme editor.
  document.addEventListener('load', event => update(event.target), true);
  document.addEventListener('error', event => {
    if (event.target.matches?.(selector)) event.target.classList.remove('is-loaded');
  }, true);
  const scan = root => root.querySelectorAll(selector).forEach(update);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
